// DonationSection.js
import React from "react";

const DonationSection = () => {
  const handleDonateViaPaypal = () => {
    const paypalLink =
      "https://paypal.me/saurabhnative?country.x=IN&locale.x=en_GB";
    window.open(paypalLink, "_blank");
  };
  const handleBuyMeACoffee = () => {
    const kofiLink = "https://ko-fi.com/saurabhmhatre";
    window.open(kofiLink, "_blank");
  };
  return (
    <section className="bg-blue-700 text-white py-16">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8">
          Support React30
        </h2>
        <p className="text-lg md:text-xl lg:text-2xl mb-8">
          Help us continue creating quality content by making a donation.
        </p>
        <div className="flex justify-center space-x-4">
          <button
            className="bg-white text-sm text-blue-700 py-2 px-6 rounded-full hover:bg-gray-300"
            onClick={handleDonateViaPaypal}
          >
            Donate via PayPal
          </button>
          <button
            className="bg-white text-sm text-blue-700 py-2 px-6 rounded-full hover:bg-gray-300"
            onClick={handleBuyMeACoffee}
          >
            Buy Me A Coffee
          </button>
        </div>
      </div>
    </section>
  );
};

export default DonationSection;
